"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.addQuestion = void 0;
const addQuestionNode_1 = __importDefault(require("./addQuestionNode"));
const visitQuestionNode_1 = __importDefault(require("./visitQuestionNode"));
const addQuestion = (form, parentTreeNode, node, answer, rule, index = -1
// eslint-disable-next-line max-params
) => {
    const { answers, questions, rules } = form;
    const child = (0, addQuestionNode_1.default)(parentTreeNode, node, index);
    questions[node.nodeId] = child;
    (0, visitQuestionNode_1.default)(child, (n) => {
        answers[n.nodeId] = {};
        questions[n.nodeId] = n;
    });
    answers[node.nodeId] = answer;
    rules[node.questionId] = rule;
    return child;
};
exports.addQuestion = addQuestion;
exports.default = exports.addQuestion;
